import { FC } from 'react';
import { Field, useForm } from 'react-final-form';
import colors from 'constants/colors';

interface ColorPickerFormProps {
  bgColorFieldName?: string;
  textColorFieldName?: string;
  showResetButton?: boolean;
  disabled?: boolean;
}

export const ColorPickerForm: FC<ColorPickerFormProps> = ({
  bgColorFieldName = 'bg_color',
  textColorFieldName = 'text_color',
  showResetButton = true,
  disabled = false,
}) => {
  const { change } = useForm();

  const handleResetColors = () => {
    change(bgColorFieldName, null);
    change(textColorFieldName, null);
  };

  return (
    <div className="column gap4">
      <div className="row gap4">
        <Field name={bgColorFieldName} allowNull>
          {({ input: bgInput, meta: bgMeta }) => (
            <div className="grid-column form-group margin0">
              <label htmlFor={`${bgColorFieldName}-input`}>Background Color</label>
              <input
                id={`${bgColorFieldName}-input`}
                name={`${bgColorFieldName}-input`}
                type="color"
                className="input-color"
                value={!bgInput.value ? colors.inkBlue : bgInput.value}
                onChange={e => bgInput.onChange(e.target.value)}
                disabled={disabled}
              />
              {bgMeta.error && bgMeta.touched && (
                <label htmlFor={`${bgColorFieldName}-input`} className="error">
                  {bgMeta.error}
                </label>
              )}
            </div>
          )}
        </Field>

        <Field name={textColorFieldName} allowNull>
          {({ input: textInput, meta: textMeta }) => (
            <div className="grid-column content-start form-group margin0">
              <label htmlFor={`${textColorFieldName}-input`}>Text Color</label>
              <input
                id={`${textColorFieldName}-input`}
                name={`${textColorFieldName}-input`}
                type="color"
                className="input-color"
                value={!textInput.value ? colors.white : textInput.value}
                onChange={e => textInput.onChange(e.target.value)}
                disabled={disabled}
              />
              {textMeta.error && textMeta.touched && (
                <label htmlFor={`${textColorFieldName}-input`} className="error">
                  {textMeta.error}
                </label>
              )}
            </div>
          )}
        </Field>
      </div>
      {showResetButton && (
        <div className="row">
          <button type="button" className="show-reset-button link-text" onClick={handleResetColors}>
            Reset Colors
          </button>
        </div>
      )}
    </div>
  );
};
